module.exports = __webpack_public_path__ + "static/media/CHUONGTRINHGIANGDAY-01.e7526918.png";